import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";

export default function ClearAllorOnebyOne({ setfilter }) {
  const {
    state,
    clearAllFilterFields,
  } = useAllFilterBaseContext();
  const {
  } = state;


  const handleClearFilters = () => {
    if (setfilter) {
      setfilter(false);
    }
    clearAllFilterFields();
  };

  return (
    <div>
      <div className="filter-head">
        <h4>Filters</h4>
        <a onClick={() => handleClearFilters()}>Clear filters</a>
      </div>
    </div>
  );
}
